import '../Footer/Footer.scss';


function Footer() {


    return (

        <>

            <hr />
            <div className="footerContainer">
                <div className="footer">
                    <h4 className="footer_header">CUSTOMER SERVICE</h4>

                    <div className="footer_text">
                        <p>Shipping & Delivery Policy</p>
                        <p>Return, Exchange and Refunds policy for Bags</p>
                        <p>Return, Exchange and Refunds policy for heels</p>
                        <p> Privacy Policy</p>
                        <p> Color Variation and Wear Tear</p>
                        <p>Terms of Service</p>
                        <p> Intellectual Property & Trademarks</p>
                        <p>Contact Us</p>
                    </div>
                </div>
            </div>

            <div className='copy_right'>

                <p>
                    © Rashki <br />
                    Design by Marstechs
                </p>
            </div>

        </>
    )
};

export default Footer;